import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './mount-components'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/scss/main.scss'



Vue.config.productionTip = false

// BootstrapVue
import BootstrapVue from 'bootstrap-vue'


Vue.use(BootstrapVue)

const VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
  container: "#tabcont__BV_tab_controls_",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: true,
  y: false
});
// Swiper
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'

// Vue.use(VueAwesomeSwiper, /* { default global options } */)

import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)


import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents);

import {ParallaxContainer, ParallaxElement} from 'vue-mouse-parallax'

Vue.component('parallax-container', ParallaxContainer)
Vue.component('parallax-element', ParallaxElement)

import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)

import Paginate from 'vuejs-paginate'

Vue.component('paginate', Paginate)

import vmodal from 'vue-js-modal'

Vue.use(vmodal)

Vue.component('resizable-textarea', {
	methods: {
		resizeTextarea (event) {
			event.target.style.height = 'auto'
			event.target.style.height = (event.target.scrollHeight) + 'px'
		},
	},
	mounted () {
		this.$nextTick(() => {
			this.$el.setAttribute('style', 'height:' + (this.$el.scrollHeight) + 'px;overflow-y:hidden;')
		})
		
		this.$el.addEventListener('input', this.resizeTextarea)
	},
	beforeDestroy () {
		this.$el.removeEventListener('input', this.resizeTextarea)
	},
	render () {
		return this.$slots.default[0]
	},
});



new Vue({
  router,
  store,
  render: h => h(App),
	data() {
		return {
			domainLink: '',
			itemdata:{},
			routLink:'https://gorsi.ru/api',
			vacancy:'',
			stopScroll:false,
			politconf:'',
		}
	},
	methods: {
		
		showVacant (item) {
			this.modalData = item
			this.$modal.show('card_modal')
			this.stopScroll = true
		},
		hideVacant () {
			this.$modal.hide('card_modal')
			this.stopScroll = true
			
		},
		showCallback() {
			this.$modal.show('modal-form-callback')
			this.stopScroll = true
		},
		hideCallback() {
			this.$modal.hide('modal-form-callback')
			this.stopScroll = false
		},
		hideNews() {
			this.$modal.hide('modal-news')
			this.stopScroll = false
		},
		showSend(vacancy) {
			this.vacancy = vacancy;
			this.$modal.show('modal-form-send')
			this.stopScroll = true
		},
		hideSend() {
			this.$modal.hide('modal-form-send')
			this.stopScroll = false
		},
		showSuc() {
			this.$modal.show('modal-form-success')
			this.stopScroll = true
		},
		hideSuc() {
			this.$modal.hide('modal-form-success')
			this.stopScroll = false
		},
		getlink(link) {
			this.domainLink = link;
		},
		beforeClose() {
			this.stopScroll = false
		}
	},
	watch: {
		stopScroll(val) {
			if (val) {
				document.body.style.overflow='hidden'
			} else {
				document.body.style.overflow='auto'
			}
		}
	}

}).$mount('#app')

var filter = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);
